import React from 'react';
import { Route } from 'react-router-dom';

const AuthenticatedRoute = ({ component, isAuthenticated, path }) =>
    isAuthenticated ? <Route component={component} path={path} /> : null;

export default AuthenticatedRoute;
